<script>
  import { onMount, onDestroy } from 'svelte';
  import { browser } from '$app/environment';
  import { getContext } from 'svelte';

  export let DESKTOP_MIN = 1280;
  export let TABLET_MIN = 1060;

  import jQuery from 'jquery';
  const userAgentDeviceType = getContext('deviceType');

  export let desktop = userAgentDeviceType == 'desktop';
  export let tablet = userAgentDeviceType == 'tablet';
  export let mobile = userAgentDeviceType == 'mobile';

  let resizeTimer;
  let id = Date.now() + Math.floor(Math.random() * 100);

  let addDisplayClass = function () {
    if (!browser) {
      return;
    }

    let width = jQuery(window).width();

    if (width < TABLET_MIN) {
      mobile = true;
    } else {
      mobile = false;
    }

    if (width >= TABLET_MIN && width < DESKTOP_MIN) {
      tablet = true;
    } else {
      tablet = false;
    }

    if (width >= DESKTOP_MIN) {
      desktop = true;
    } else {
      desktop = false;
    }
  };

  $: TABLET_MIN && addDisplayClass();

  onMount(() => {
    jQuery(window).on(`resize.${id}`, function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(addDisplayClass, 250);
    });
  });

  onDestroy(() => {
    browser && jQuery(window).off(`resize.${id}`);
  });
</script>

{#key [desktop, tablet, mobile]}
  <slot desktop={desktop} tablet={tablet} mobile={mobile} />
{/key}
